import React from 'react';

import DocumentInput, {
  DocumentState,
} from 'Jsx/CheckoutV4/components/UserDataFields/DocumentInput';

import AddressInput, {
  AddressState,
} from '../../../UserInputFields/AddressInput';
import CityAndStateInput, {
  CityAndStateState,
} from '../../../UserInputFields/CityAndStateInput/CityAndStateInput';
import EmailInput, { EmailState } from '../../../UserInputFields/EmailInput';
import ZipCodeInput, {
  ZipCodeState,
} from '../../../UserInputFields/ZipCodeInput/ZipCodeInput';
import PhoneInput, { PhoneState } from '../../../UserInputFields/PhoneInput';

interface FormFieldsDisplay {
  email: boolean;
  document: boolean;
  cityAndState: boolean;
  address: boolean;
  phone: boolean;
  zipCode: boolean;
}

interface FormElementsProps {
  onAddressChange?: (state: AddressState) => void;
  onEmailChange?: (state: EmailState) => void;
  onZipCodeChange?: (state: ZipCodeState) => void;
  onDocumentChange?: (state: DocumentState) => void;
  onCityAndStateChange?: (state: CityAndStateState) => void;
  onPhoneChange?: (state: PhoneState) => void;
  displayFields?: FormFieldsDisplay;
}

const defaultFunction = () => {};

const showAllFields = {
  email: true,
  document: true,
  cityAndState: true,
  address: true,
  phone: true,
  zipCode: true,
};

const UserDataInput = ({
  onAddressChange = defaultFunction,
  onCityAndStateChange = defaultFunction,
  onDocumentChange = defaultFunction,
  onEmailChange = defaultFunction,
  onPhoneChange = defaultFunction,
  onZipCodeChange = defaultFunction,
  displayFields = showAllFields,
}: FormElementsProps) => {
  const { email, address, zipCode, document, cityAndState, phone } =
    displayFields;

  return (
    <>
      {email && <EmailInput onEmailChange={onEmailChange} />}
      {document && <DocumentInput onChange={onDocumentChange} />}
      {phone && <PhoneInput onPhoneChange={onPhoneChange} />}
      {address && <AddressInput onAddressChange={onAddressChange} />}
      {cityAndState && (
        <CityAndStateInput onCityAndStateChange={onCityAndStateChange} />
      )}
      {zipCode && <ZipCodeInput onZipCodeChange={onZipCodeChange} />}
    </>
  );
};

export default UserDataInput;
